
import { Vue, Component } from 'vue-property-decorator';
import ContentWrapper from '@/components/ContentWrapper.vue';
import SiteWrapper from '@/components/SiteWrapper.vue';
import JTMSDashboardOverview from './DashboardOverview/JTMSDashboardOverview.vue';

@Component({
  components: { SiteWrapper, ContentWrapper, JTMSDashboardOverview }
})
export default class JTMSDashboard extends Vue {}
